import React from 'react';

import { PDFViewer } from '@react-pdf/renderer';

import SalesInvoicePDF from './SalesInvoicePDF';
import PurchaseInvoicePDF from './PurchaseInvoicePDF';
import { buildInvoiceData } from './PdfData';

const InvoicePreview = ({ digest, invoiceType, reference }) => {
    const data = buildInvoiceData({ digest, invoiceType, reference});

    if (invoiceType === 'sales') {
        return (
            <PDFViewer width='100%' height='800px'>
                <SalesInvoicePDF {...data} />
            </PDFViewer>
        );
    }
    else {
        return (
            <PDFViewer width='100%' height='800px'>
                <PurchaseInvoicePDF {...data} />
            </PDFViewer>
        );
    }
};

export default InvoicePreview;